import { network } from 'lib/network';
import { EventAsSeasonSegment } from 'types/events';
import { Season, SeasonAsSegment } from 'types/seasons';
import { EventsAndConflictsDto } from '@bondsports/types'

const apiUrl = process.env.BOND_SPORTS_API_URL;
const v4ApiUrl = `${process.env.BOND_SPORTS_API_URL}v4/programs-seasons/`;

async function getProgramSeasons(programId: number): Promise<Season[]> {
	const response = await network.get(`${apiUrl}v4/programs-seasons/program/${programId}`);

	return response.data;
}

async function getSubSeasons(
	seasonId: number,
	futureResources = false
): Promise<EventAsSeasonSegment[] | SeasonAsSegment[]> {
	const response = await network.get(`${apiUrl}v1/programs/segments/${seasonId}?futureResources=${futureResources}`);

	return response.data;
}

async function getSeasonData_DEPRICATED(seasonId: number): Promise<Season> {
	const response = await network.get(`${apiUrl}v1/programs/season/${seasonId}`);

	return response.data;
}

async function getSeasonData(seasonId: number): Promise<Season> {
	const response = await network.get(`${v4ApiUrl}${seasonId}`);
	return response;
}

async function getEvents(seasonId: number): Promise<EventsAndConflictsDto> {
	const response = await network.get(`${apiUrl}v1/programs/events/${seasonId}`);
	return response.data;
}

export const seasonApi = {
	getProgramSeasons,
	getSubSeasons,
	getSeasonData,
	getSeasonData_DEPRICATED,
	getEvents,
};
